module.exports = __webpack_public_path__ + "img/AFMS-Calendar.7912e872.png";